


































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { app } from "@/models/Application";
import { Debouncer } from "@/models/Debouncer";
import { Promotion } from "@/viewmodels/Promotion";
import { DateUtils } from "@/utils/DateUtils";

@Component({})
export default class extends Vue {
  public collection = app.promotionCollection;
  public products = app.productCollection;
  public search: string = "";
  public selectedProductList = [];

  public model: Promotion = new Promotion({}, this.collection);
  public selectedModel: Promotion | null = null;

  public dialog = false;
  public formTitle: string = "Add Promotion";

  public headers = [
    { text: "Name", value: "Name" },
    { text: "Description", value: "Description" },
    { text: "Period", value: "startDate" },
    { text: "Products", value: "all_products" },
    { text: "Actions", value: "", sortable: false }
  ];

  public discountTypes = [
    { value: 1, text: "Fixed Amount", symbol: "$" },
    { value: 2, text: "Percent", symbol: "%" }
  ];

  public productHeaders = [
    { text: "Name", value: "name", sortable: false },
    { text: "Category", value: "category", sortable: false }
  ];

  public getDiscountSymbol(id: any) {
    let item = this.discountTypes.find((e: any) => e.value === id);
    if (item) {
      return item.symbol;
    }
    return "";
  }

  public get selectedProducts() {
    const models = this.products.models;
    const selected = this.model.productList || []; //  this.selectedProductList;

    return models.filter((m: any) => {
      return selected.indexOf(m.id) > -1;
    });
  }

  public getPeriodText(model: Promotion): string {
    if (model) {
      const startDate = DateUtils.dateToYmd(model.startDate);
      const endDate = DateUtils.dateToYmd(model.endDate);
      return `${startDate} - ${endDate}`;
    }
    return "";
  }

  public mounted() {
    this.search = this.collection.search;
    this.collection.refreshData();
  }

  @Watch("search")
  public onSearchChange() {
    this.collection.doSearch(this.search);
  }

  public remove(model: any) {
    const dialog: any = (this.$root as any).$confirm;

    dialog("Delete", "Are you sure?").then((confirm: boolean) => {
      if (confirm) {
        model.delete();
      }
    });
  }

  public close() {
    this.dialog = false;
  }

  public sendSMS() {
    const dialog: any = (this.$root as any).$confirm;

    dialog(
      "Send SMS",
      "Are you sure you want to notify all customers about this promotions?"
    ).then((confirm: boolean) => {
      if (confirm) {
        this.model.sendSMS();
      }
    });
  }

  public async save() {
    try {
      await this.model.save();
      this.dialog = false;
      this.$store.dispatch("showSnackbar", { message: "Saved succesfully!" });
    } catch (e) {
      console.log("Error", e);

      this.$store.dispatch("showSnackbar", {
        message: "Whoops, error while saving data!"
      });
    }
  }

  public add() {
    this.model = new Promotion({}, this.collection);
    this.dialog = true;
  }

  public edit(item: Promotion) {
    this.model = item;
    this.dialog = true;
  }
}
